<template>
  <MglMap :class="{ 'map-rounded': isRounded }" :style="{ width: '50', height: divHeight }" :accessToken='accessToken' :mapStyle.sync='mapStyle'
          @load='onMapLoaded($event)' :zoom='4' :trackResize="true" :repaint="true">
    <MapInfofeatureSelect :selected-feature='selectedFeature' :layer-info='layerInfo'
                          v-on:closeInfo='layerInfo=!layerInfo'></MapInfofeatureSelect>
    <MapFilter v-if='stages' :stages='stages' v-on:filterMap='filterMap($event)' />

    <MapLayers :layers='layers' :zoom='zoomLevel' :mapboxMap='map' v-on:layerMap='layerMap($event)'/>

    <MglPopup :closeOnClick='false' :coordinates='popUpCoordinates' :showed='true'
              ref='popup' style='width: 100%'>
      <popup-content :content='popUpContent' :template='popUpTemplate'></popup-content>
    </MglPopup>

    <MglGeocoderControl :accessToken='accessToken' :marker=false v-if='geolocateControl' @results='handleSearch' />
    <MglNavigationControl position='top-right' />
    <MglGeolocateControl position='top-right' />
    <MglScaleControl position='bottom-left' v-if='scaleControl' />
    <MglFullscreenControl position='top-right' v-if='fullScreenControl' />
    <MapStyleSelect v-if='actionStyle' :mapStyle='confStyle' />
    <MapColorPicker v-if='actionColor' v-on:colorChange='colorChangeMap()' />
  </MglMap>
</template>
<script>
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import MglGeocoderControl from 'vue-mapbox-geocoder';
import popupContent from './PopupContent.vue';
import MapStyleSelect from "./MapStyleSelect.vue";
import MapFilter from "./MapFilter.vue";
import MapInfofeatureSelect from "./MapInfoFeatureSelect.vue";
import MapColorPicker from "./MapColorPicker.vue";
import MapLayers from './MapLayers.vue'
import _ from 'lodash';
import * as turf from '@turf/turf';

import {
  MglAttributionControl,
  MglFullscreenControl,
  MglGeolocateControl,
  MglMap,
  MglMarker,
  MglNavigationControl,
  MglPopup,
  MglScaleControl,
} from 'vue-mapbox';

export default {
  components: {
    MapLayers,
    MapInfofeatureSelect,
    MapFilter,
    MapStyleSelect,
    MapColorPicker,
    MglMap,
    MglPopup,
    MglMarker,
    MglAttributionControl,
    MglNavigationControl,
    MglGeolocateControl,
    MglFullscreenControl,
    MglScaleControl,
    MglGeocoderControl,
    popupContent
  },
  props: [
    'navigationControl',
    'geolocateControl',
    'scaleControl',
    'fullScreenControl',
    'drawControl',
    'searchControl',
    'displayDrawControlsDefault',
    'drawControls',
    'mapHeight',
    'oneLocation',
    'mapConfiguration',
    'confStyle',
    'viewControls',
    'stages',
    'layers',
    'userLayers',
    'actionStyle',
    'actionColor',
    'popUpData',
    'isRounded'
  ],
  data() {
    return {
      drawPolygon: [],
      divWidth: '100',
      divHeight: '100vh',
      accessToken: process.env.VUE_APP_MAPBOX_KEY, // your access token. Needed if you using Mapbox maps
      mapStyle: "mapbox://styles/mapbox/" + this.confStyle, // your map style
      defaultInput: '',
      drawTool: null,
      areaDrawn: -1,
      sourceToDraw: false,

      layerClickSelected: null,
      layerClickSelectedOn: null,
      layerHoverSelected: null,

      popUpCoordinates: [-79.549668, 39.014],
      popUpShow: false,
      popUpContent: null,
      popUpTemplate: null,

      // permit EVENTS
      eventClick: true,
      eventMouseleave: true,
      eventMousemove: true,

      //laer info panel
      selectedFeature: null,
      layerInfo: false,
      zoomLevel: 0

    };
  },
  created() {
    this.map = null;
    this.drawPolygon.push(document.getElementsByClassName('mapbox-gl-draw_polygon'));
    this.drawPolygon.push(document.getElementsByClassName('mapbox-gl-draw_point'));
    if (this.mapHeight) {
      this.divHeight = this.mapHeight + 'vh';
    }
    // this.map.setLayoutProperty('mapbox-mapbox-satellite', 'visibility','visible');
  },
  // watch: {
  //   areaDrawn() {
  //     this.$emit('areaChange');
  //   }
  // },
  methods: {
    async onMapLoaded(event) {
      this.$emit('on:loaded', true);
      // in component
      this.map = event.map;
      // or just to store if you want have access from other components
      this.$store.map = event.map;
      this.addSource('TrackingSourceAdmin', {"type": 'geojson', "data": {type: 'FeatureCollection', features: []}});
      this.map.loadImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABIZJREFUaEPtmVtoHGUUx/9ntgsGDdqH0FYN2flmQwoVxRRKC6KxrW2xmVlaoRXJg1Av6IuKL4J4yYsgiDcQKhX6oIIWQXe2rZIqSQWrCKKo8Zr5Zg2mIiKRUmIw3TkyYYU2bGbONzNBCp2nhf2fc/6/73y32SVc5A9d5P5xCeD/7mChHWgotY2JdoF5M4BrAKxpA/4OYIaZP7VKpePu1NREUeC5AcaHhladmZ6+1wKeYGCd0NgMMY9e0dd3+NaJiXPCmI6yXAB1276eiN4B0J/FBAM/lYjuGA6Cb7PExzGZAepK7SXgDQBdWYu34+ZgWXd5U1P1LHkyAfhKDQPw8wzAErNMRHvdIHjPFMIYoD1tPitg5Jd6/dsi2mQ6nYwAjgCly5T6AUDVdKSE+u9cra8jgIV6szXgK/UggFekybPoiPk+NwwPSWPFHagPDHTTwsIvAFZLk2fU/UHz8xX39Ok5SbwYwHecu8F8WJIUQMMiGl1otYJYXy6VHGYeZWC3JJ6AEVfrN4VaiQzwHecQmO8RqJ/1tH6sk853nOfA/GhaDgYO1rR+IE1ndA74tn0KRFuSkhIw7mq9dTkNA3RUqTEGtqeY+9jT+pZiAZTSAOwUgO2u1h8laeqOs4uY30/SxCd0TeuBQgEaSv3DQDkpaSuKVu9pNv9KBOjtvZrK5ZkUc2c8ra8sFMBXKt4VEq8NzLy2FobxzXPZ51ilsrZlWb+lmJvztL68aIBpAL2JrWfeUQvDE3mnEICmp3XidP2vhnwbte1xEA2lrIEPXa1vS1rEDaViwG0po3vC03pHsR2Qb4HP17TuuFX6Sr0A4OFUY0TPeEHweKrO5DbpV6s1RJHstkj0PYAXW63WmFUqrSJgK5gfAbBeYgrMO70wHJNoxVPo1Y0by+tmZ/8E0C1JnEMzO691zz6gJckhBoiT+Uq9BuCAJHFWDQEvuVqnT7N2ASOARrW6haPoVFZzkjgm6q8FwZREG2uMANpdiN9fN0gLGOmITnpBkLjTLc1nDFC37REiet3ImFDMwHBN62NC+aLMGKDdhV/bv/uY1ErTfu1pfUOaKHcH4gQNx9nPzG+ZFkvSM9FNtSD4xDRnpg60u3ASwM2mBTvqiY54QbA/S67MAI1qdZCj6IssRc+PIWDBYu7fHYbx66rxkxmg3YV4MY8YV70wYNk3OEneXAB1215DRD8CEN3dOxiame/qWr9vcvKsxGwnTS6AxS7Y9gEQxSe08UNA6htcWtLcAO2pFO/dt6cVWzL3ja4My+UuBODdSuUqy7K+IeBaCQQDX9W0vlGiTdMUArDYhUplMywr3setlKJzrSjasKfZbKaZk3xfGEB7Ko0CeDKpMBHd6QbB2xJzEk2hAE8D1qBS48secMwve2H4kMSYVFMoQFz0eLXacy6KJgH0XGCC+cvuvr5Nef9SWgpWOEBc4GilsjOyrA/OK3aWgEFX65+lIyvVrQjA4npwnPvBfDD+nPWiJoFYMYC4eEOpp5jocy8IEn9KlBhd0XMgj4G8sSvagbzmJPGXACSjtJKafwHSVWlA2HKFBwAAAABJRU5ErkJggg==', (error, image) => {
        console.log(error);
        if (error) {
          throw error;
        }
        this.map.addImage('redIcon', image);
        this.map.addLayer({
          id: 'points',
          type: 'symbol',
          source: 'TrackingSourceAdmin',
          layout: {
            'icon-image': 'redIcon',
            'icon-size': 0.75
          }

        });
      });
      this.map.loadImage('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABJRJREFUaEPtWWtoHFUU/s7srija2mZn0/goKBosVhT7o7QgPtraFq2Iyc5WS34I1YqCNDurRRA1+SOI2dlUUKoW+sP3zBatUpVUiRWsIoji2/qgPuKje7cNIURpdubIpBsIy2bm3tkJGuj8W/Y73/m+e+45e+8sYZ4/NM/145SB/7qCsVYgbTprCdgIYBWA8wAsqRv8C8AIiD4E8ZtiwHgvLuOtG+gbTqbHKncS6CEA50gKGwGoXyxM70HfdTXJmKawlgy031e+3HO5DEJnNBF02NW07uMDXV9Gi0f0Jk4XnC5iPA/gjKjJ63ETzNhSLRn7ovBEqoBuOpsAvI4WFqBBLDNRV7WYfU3VhLKBqW3j8UcxrHyj1r9dLbFSdTupGTDshL6UvgVwsepKSeK/Flb2MoBYEq/WA+m8cw8RnpQlj4ajbcLKPisbK10Bfce+Baid+BnAYlnyiLjKaeOnX/D7MzdNyMRLG8iY9u0M2iNDCuI3APTX3NSPPj6ZmLwIHvWDcKNcPHpE0XhBBittQDcdv6x3hJES8FjFMh5ohtMLzgAYhTAOEHaJonF3KE5lDGYKziFmrA4m5WFh5dbMjmHSC84QmNaF8LwvrNw1sRrQTecnABcGkTKwrmoZ7wZhMnl7IxO9FSyODgsre0ncBk4ASAWR1rzk4tHBW0aDMPqOl85FLTkSIm5MWMbZcRvwp0LgsUFzJzuO7tzinzxnfTL32x3s0h8h4iaEZZwZs4HyLwAvDSL1iNcfK+YOtLqFGHSkamUDt+t0DvkplHeGQbg2cFWI3xHF3PWBTWyWfYNrg3gIOFCxjPXxVkB2BIIsYWWbjkrddEoAesOEMePRasl4MAznfy9dgXTeuZkIkqdF/gaEwaTrDrmUSLKGNWDKA1gmI8pjbDhWMoZksNIGsO3plH5WWxXAAhniFjDHxa+cgZNzZTjkDQDQzfJugLfKEEfFMNPOaikbus2Um9gPaOu1V2saHYoqTiaOmDsrpdwPMlilHpgm1E3Hv78ul02giDsoLCN40jUQKm0hPzZtlnsI/JyiMDm4xpvEQG6/HPgkStmAH6Sbzm/19z4quYKxjM9FybhClTCSgYxpb2bQy6rJgvCap111dLD7A1XOSAZOVsE+CNDVqgmb4gm2KBqbo3BFN9C7dwU075MoSRtiJmukdY4Wu/3rqvIT2UC9F/xm7lHOOiMg6AYnw9uSgfbtLy7xEqnvAEid3ZsIGqF/eFnlqdy4jNhmmJYM+ISZvL2ViXZHESBzgwvjbdlAvaH3A3RDWLKZ36seGWbjjsXAot5XFyWp9gUI50uZIHwmisaVUtgQUCwG/Bxt5t5VGjx/jmshOSeSXm35n4O3HflfGZjaSoVyP5gfDhJG4FsrVu6VOMT7HLFVYEpQX5+mj106PNsPHANPVC1je1zi4zcAoONeO1NL0Vf+gGoQ+qlYqK9s9S+lRvPxVqDO3l4ob/CY356RbJwStKLyePb7OFd/TiowLVA3nbsA7PI/Rz2oyZidkwrMMPEIET6uFI2QV4kyUptj5tRAdFnykacMyK/V3CDnfQX+BZVBZEC4warmAAAAAElFTkSuQmCC', (error, image) => {
        console.log(error);
        if (error) {
          throw error;
        }
        this.map.addImage('blueIcon', image);
      });
      this.addSource('RouteAdmin', {"type": 'geojson', "data": {type: 'FeatureCollection', features: []}});
      this.map.addLayer({
        'id': 'route',
        'type': 'line',
        'source': 'RouteAdmin',
        'layout': {
          'line-join': 'round',
          'line-cap': 'round'
        },
        'paint': {
          'line-color': '#03AC8C',
          'line-width': 3
        }
      });
      // CONFIG
      this.setMapConfig();

      // CONTROLS
      //     point: true,
      //     line_string: true,
      //     polygon: true,
      //     trash: true,
      //     combine_features: true,
      //     uncombine_features: true
      setTimeout(() => {
        if (this.drawControl === true) {
          this.drawTool = new MapboxDraw({
                displayControlsDefault: this.displayDrawControlsDefault,
                controls: this.drawControls
              }
          );
          this.map.addControl(this.drawTool, 'top-right');
          console.log("addDrawMap");
        }
      }, 500);
      // EVENTS DRAW
      this.map.on('draw.create', this.onCrateEvent);
      this.map.on('draw.update', this.onUpdateEvent);
      this.map.on('draw.delete', this.onDeleteEvent);
      this.map.on('draw.modechange', this.onModeDrawSelect);
      this.map.on('style.load', () => {
        this.styleLoad();
      });
      this.map.on('zoom', () => {
        this.zoomLevel =  this.map.getZoom().toFixed(0) // Actualizar el nivel de zoom en el badge
      })

      setTimeout(() => {
        console.log("loadComplete");
        this.$emit('on:loaded', false);
        this.$emit('loadComplete');
      }, 1000);
    },
    styleLoad() {
      if (this.map.isStyleLoaded()) {
        this.$emit('styleLoad');
      } else {
        setTimeout(() => {
          this.styleLoad();
        }, 600)
      }
    },
    setPermitEvent(eventPermit) {
      switch (eventPermit) {
        case 'eventClick':
          this.eventClick = !this.eventClick;
          break;
        case 'eventMouseleave':
          this.eventMouseleave = !this.eventMouseleave;
          break;
        case 'eventMousemove':
          this.eventMousemove = !this.eventMousemove;
          break;
      }
    },
    deleteMapConfig() {
      console.log('delete map config')
      if (this.mapConfiguration) {
        if (this.mapConfiguration.layers && this.mapConfiguration.layers.length > 0) {
          for (const layer of this.mapConfiguration.layers) {
            if (this.getLayer(layer.id)) {
              this.removeLayer(layer.id);
            }
          }
        }
        for (const source of this.mapConfiguration.sources) {
          if (this.getSource(source.id)) {
            this.removeSource(source.id);
          }
        }
      }
    },
    setMapConfig() {
      console.log('set map config')
      if (this.mapConfiguration) {
        for (const source of this.mapConfiguration.sources) {
          this.addSource(source.id, source.config);
        }
        if (this.mapConfiguration.layers && this.mapConfiguration.layers.length > 0) {
          for (const layer of this.mapConfiguration.layers) {
            if (layer.source && this.getSource(layer.source) && this.layers && this.userLayer(layer.id)) {
              this.setVisibility(layer)
              this.addLayer(layer, layer.beforeLayer ? layer.beforeLayer : null);
            }
          }
        }
        if (this.mapConfiguration.filters && this.mapConfiguration.filters.length > 0) {
          for (const filter of this.mapConfiguration.filters) {
            if (filter.layer && this.getLayer(filter.layer)) {
              this.activateDeactivateFilter(filter.layer, filter.property, filter.value);
            }
          }
        }
      }
    },
    userLayer(id){
      return _.some(this.layers, { id: id });
    },
    setVisibility(layer){
      const userLayer  =  _.some(this.layers, { id: layer.id, checked: true });
      if(userLayer){
        layer.layout.visibility = 'visible'
      } else {
        layer.layout.visibility = 'none'
      }
    },
    getLayerClickSelected() {
      return this.layerClickSelected;
    },
    getLayerHoverSelected() {
      return this.layerHoverSelected;
    },
    filterMap(value) {
      this.$emit("filterDash", value);
    },
    layerMap(value) {
      this.addLayer(value.id)
    },
    colorChangeMap() {
      this.$emit("colorChange");
    },
    onLayerClickTrackingSelected() {
      const mapSelected = this.getLayerClickSelected();
      this.selectedFeature = mapSelected.properties;
      this.$emit("openSheetTracking", [mapSelected.properties]);
    },
    onLayerClickSelected() {
      const mapSelected = this.getLayerClickSelected();
      this.selectedFeature = mapSelected.properties;
      this.layerInfo = true;
    },
    onLayerHoverSelected() {
      const mapSelected = this.getLayerHoverSelected();
      this.selectedFeature = mapSelected.properties;
      this.layerInfo = true;
    },
    activateDeactivateFilter(layer, filterProperty, filterValue) {
      this.map.setFilter(layer, ['in', filterProperty, filterValue]);
    },
    onMouseHoverInfo(layer, cursor) {
      const map = this.map;
      this.map.on('mousemove', layer, (e) => {
        let featureByOrder = null;
        if (this.eventMousemove && e.features.length > 0) {
          featureByOrder = _.orderBy(_.map(e.features, (feature) => {
            return {
              ...feature,
              order: feature.properties.order
            };
          }), ['order'], ['asc'])[0];
          this.layerHoverSelected = featureByOrder;
          this.onLayerHoverSelected();
          map.getCanvas().style.cursor = cursor;
        }
      });
    },
    onMouseLeaveInfo(layer) {
      const map = this.map;
      this.map.on('mouseleave', layer, () => {
        if (this.eventMouseleave) {
          map.getCanvas().style.cursor = '';
          this.layerInfo = false;
        }
      });
    },
    onMouseHoverChangeCursor(layer, cursor) {
      const map = this.map;
      this.map.on('mouseenter', layer, () => {
        map.getCanvas().style.cursor = cursor;
      });
    },
    onMouseLeaveChangeCursor(layer) {
      const map = this.map;
      this.map.on('mouseleave', layer, () => {
        if (this.eventMouseleave) {
          map.getCanvas().style.cursor = '';
        }
      });
    },
    onMouseHoverPopUp(layers, cursor, template) {
      const map = this.map;
      _.forEach(layers, (layer, key) => {
        this.map.on('mousemove', layer, (e) => {
          let featureByOrder = null;
          if (this.eventMousemove && e.features.length > 0) {
            featureByOrder = _.orderBy(_.map(e.features, (feature) => {
              return {
                ...feature,
                order: feature.properties.order
              };
            }), ['order'], ['asc'])[0];
            if (this.layerHoverSelected) {
              map.getCanvas().style.cursor = '';
              this.removePopUp();
              this.createPopUp(featureByOrder, e.lngLat, template);
            } else if (this.layerHoverSelected === null) {
              this.createPopUp(featureByOrder, e.lngLat, template);
            }
            this.layerHoverSelected = featureByOrder.layer.id;
            map.getCanvas().style.cursor = cursor;
          }
        });
      });

    },
    onMouseLeavePopUp(layers) {
      const map = this.map;
      _.forEach(layers, (layer, key) => {
        this.map.on('mouseleave', layer, (e) => {
          map.getCanvas().style.cursor = '';
          this.layerHoverSelected = null;
          this.removePopUp();
        });
      })
    },
    onMouseClickSelectTrackingLayer(layer, source) {
      this.map.on('click', layer, (e) => {
        if (this.eventClick && !this.layerClickSelectedOn) {
          this.layerClickSelected = e.features[0];
          this.onLayerClickTrackingSelected();
          this.layerClickSelectedOn = true;
          setTimeout(() => {
            this.layerClickSelectedOn = false;
          }, 500)
        }
      });
    },
    onMouseClickSelectLayer(layer, source) {
      this.map.on('click', layer, (e) => {
        if (this.eventClick && !this.layerClickSelectedOn) {
          this.layerClickSelected = e.features[0];
          this.onLayerClickSelected();
          this.layerClickSelectedOn = true;
          setTimeout(() => {
            this.layerClickSelectedOn = false;
          }, 500)
        }
      });
    },
    onMouseClickZoomLayer(layer, source) {
      this.map.on('click', layer, (e) => {
        if (this.eventClick) {
          this.layerClickSelected = e.features[0];
          let feature = {
            type: 'FeatureCollection',
            features: []
          };
          feature.features.push(e.features[0]);
          this.map.setMaxZoom(16);
          this.zoomToFitBounds(feature, 150);
          this.map.setMaxZoom(20);
        }
      });
    },
    onMouseClickClusterZoomLayer(layer, source) {
      this.map.on('click', layer, (e) => {
        const features = this.map.queryRenderedFeatures(e.point, {
          layers: [layer]
        });
        const clusterId = features[0].properties.cluster_id;
        this.map.getSource(source).getClusterExpansionZoom(
          clusterId,
          (err, zoom) => {
            if (err) return;

            this.map.easeTo({
              center: features[0].geometry.coordinates,
              zoom: zoom
            });
          }
        );
      });
    },
    onMouseClickPopup(layer, template) {
      this.map.on('click', layer, (e) => {
        this.createPopUp(e.features[0], e.lngLat, template);
      });
    },
    onCrateEvent() {
      console.log('createMap');
      this.updateAreaDrawn();
      this.$emit('createMap', this.getLocationsDrawnObject());
    },
    onUpdateEvent() {
      console.log('updateMap');
      this.updateAreaDrawn();
      this.$emit('updateMap', this.getLocationsDrawnObject());
    },
    onDeleteEvent() {
      console.log('deleteMap');
      this.updateAreaDrawn();
      this.$emit('deleteMap', this.getLocationsDrawnObject());
    },
    onModeDrawSelect(event) {
      console.log('selectedDrawControl');
      this.$emit('selectedDrawControl', event.mode);
    },
    createPopUp(feature, lngLat, template) {
      this.popUpShow = true;
      this.popUpCoordinates = [lngLat.lng, lngLat.lat];
      this.popUpContent = feature;
      this.popUpTemplate = template;
      this.$refs.popup.popup.addTo(this.map); // not the best way to do this
    },
    removePopUp() {
      this.$refs.popup.popup.remove();
    },
    updateAreaDrawn(e) {
      this.activateDeactivate();
      const data = this.drawTool.getAll();
      if (data.features.length > 0) {
        const area = turf.area(data);
        this.areaDrawn = Math.round(area * 100) / 100;
        this.areaDrawn = this.areaDrawn - this.calculateIntersectsAreaDrawn();
        console.log(this.areaDrawn)
        this.$emit('areaChange', this.areaDrawn)
        // this.zoomToFitBoundsDrawn();
      } else {
        this.areaDrawn = 0;
        this.$emit('areaChange', this.areaDrawn)
      }
    },
    addGeoJsonToDraw(geojson) {
      if (this.drawTool) {
        this.drawTool.add(geojson);
        this.activateDeactivate();
        this.zoomToFitBoundsDrawn();
      }
    },
    existDraw(){
      if(this.drawTool !== null){
        const data = this.drawTool.getAll();
        return data.features.length > 0;
      } else {
        return false;
      }
    },
    activateDeactivate() {
      if (this.oneLocation) {
        if (this.drawTool && this.drawTool.getAll().features.length > 0) {
          this.deactivateDrawTool();
        } else {
          this.activateDrawTool();
        }
      }
    },
    removeLayer(id) {
      this.map.removeLayer(id);
    },
    setMapZoom(zoom) {
      this.map.setMaxZoom(zoom);
    },

    addLayer(layer, beforeLayer) {
      if (beforeLayer) {
        this.map.addLayer(layer, beforeLayer);
      } else {
        this.map.addLayer(layer);
      }

    },

    getLayer(id) {
      return this.map.getLayer(id);
    },
    getSource(id) {
      return this.map.getSource(id);
    },
    removeSource(id) {
      this.map.removeSource(id);
    },
    addSource(id, config) {
      this.map.addSource(id, config);
    },
    updateSource(id, data) {
      this.map.getSource(id).setData(data);
    },
    updateMonitoring(featuresBySDT) {
      if (featuresBySDT) {
        let allFeatures = {
          type: 'FeatureCollection',
          features: []
        };
        console.log(featuresBySDT);
          _.forEach(featuresBySDT.features, (feature) => {
            let point = turf.center(feature);
            point.properties = feature.properties;
            allFeatures.features.push(point);
          });
          console.log(allFeatures);
        this.updateSource('icons2MonitonitoringSource', allFeatures);
      }
    },
    addIcon(sourceId, icon, name) {
      this.map.loadImage(icon, (error, image) => {
        if (error) {
          throw error;
        }
        this.map.addImage(name, image, {sdf: false});
      });
    },
    calculateIntersectsAreaDrawn() {
      let intersectsArea = null;
      const data = this.drawTool.getAll().features;
      for (let i = 0; i < data.length - 1; i++) {
        for (let a = i + 1; a < data.length; a++) {
          const intersection = turf.intersect(data[i], data[a]);
          if (intersection !== null) {
            intersectsArea = intersectsArea + turf.area(intersection);
          }
        }
      }
      return intersectsArea;
    },
    getLongLatDrawn() {
      if (this.drawTool.getAll().features.length > 0) {
        return this.getCenter(this.drawTool.getAll());
      } else {
        return [0, 0];
      }
    },
    trackingDraw(trackingData, trackingzoom, trackingLine) {
      this.addSource('TrackingSource', { "type":'geojson', "data": trackingData});
      this.map.loadImage('data:image/png;base64,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', (error, image) => {
        console.log(error);
        if (error) {
          throw error;
        }
        this.map.addImage('trackingPoint', image);
        this.map.addLayer({
          id: 'points',
          type: 'symbol',
          source: 'TrackingSource',
          layout: {
            'icon-image': 'trackingPoint',
            'icon-size': 0.75
          }

        });
        this.zoomToFitBounds(trackingzoom, 100)
      });
      this.addSource('Route', {"type":'geojson', "data": trackingLine});
      this.map.addLayer({
        'id': 'route',
        'type': 'line',
        'source': 'Route',
        'layout': {
          'line-join': 'round',
          'line-cap': 'round'
        },
        'paint': {
          'line-color': '#03AC8C',
          'line-width': 3
        }
      });
    },
    getCenter(features) {
      return turf.center(features).geometry.coordinates;
    },
    getMapCenter() {
      return this.map.getCenter();
    },
    zoomToFitBounds(features, padding) {
      if (features && features.features.length > 0)
        this.map.fitBounds(turf.bbox(features), {padding});
    },
    zoomToFitBoundsDrawn() {
      this.zoomToFitBounds(this.drawTool.getAll(), 150);
    },
    activateDrawTool() {
      _.forEach(this.drawPolygon, (value) => {
        value[0].disabled = false;
        value[0].classList.remove('disabled-button');
      });

    },
    deactivateDrawTool() {
      _.forEach(this.drawPolygon, (value) => {
        if (value.length > 0) {
          value[0].disabled = true;
          value[0].classList.add('disabled-button');
        }
      });
    },
    deleteAllDrawTool() {
      this.drawTool.deleteAll();
    },
    getAreaDrawn() {
      return this.areaDrawn;
    },
    getLocationsDrawn() {
      return JSON.stringify(this.drawTool.getAll());
    },
    getLocationsDrawnObject() {
      return this.drawTool.getAll();
    },
    handleSearch(event) {
      console.log(event);
    },
    getMapCurrentStyle() {
      //mapbox://sprites/mapbox/satellite-v9
      //mapbox://sprites/mapbox/streets-v11
      return this.map.getStyle().sprite;
    }
  },
};
</script>
<style>
.disabled-button {
  -webkit-filter: opacity(.3) drop-shadow(0 0 0 #FFF);
  filter: opacity(.3) drop-shadow(0 0 0 #FFF);
  cursor: default !important;
}

.mapboxgl-canvas {
  width: auto !important;
  max-width: 100% !important;
}

.map-rounded {
  canvas {
    border-radius: 8px !important;
  }
}
</style>
